import './index.scss';
import CommentRepliesEditor from './comment_replies_editor';
import Item from './item';
import ModalManager from 'utils/modal_manager';
import { EventManager } from 'utils/event_manager';
import { handleApiError } from 'utils/api_error_handler';

export default class CommentReplies {
  constructor(context) {
    this.$context = $(context);
    this.commentId = this.$context.data().commentId;
    this._subscribe();
    this._bindReplies();
  }

  _subscribe() {
    EventManager.subscribe(
      `commentReply.${this.commentId}.create`,
      this.createReply.bind(this)
    );
    EventManager.subscribe(
      `commentReply.${this.commentId}.update`,
      this.updateComment.bind(this)
    );
    EventManager.subscribe(
      `commentReply.${this.commentId}.delete`,
      this.deleteComment.bind(this)
    );
  }

  _bindReplies() {
    $('.js-reply-info', this._getRepliesListElement()).each(
      (i, questionComment) => {
        if (!questionComment.questionCommentInstance) {
          questionComment.questionCommentInstance = new Item(questionComment);
        }
      }
    );
  }

  _getRepliesListElement() {
    return $('.js-question-replies', this.$context);
  }

  createReply(event, data) {
    CommentRepliesEditor.createAndRender(this.commentId, 22, data.commentHTML)
      .then(response => {
        const $questionCommentList = $('.q-question-replies', this.$context);

        $questionCommentList.append(response.data);

        this._bindReplies();

        $('html, body').animate(
          { scrollTop: $questionCommentList.offset().top - 40 },
          700
        );

        EventManager.publish(`commentReply.${this.commentId}.saved`);
        toastr.success('Comentário enviado com sucesso');
      })
      .catch(() => {
        EventManager.publish(`commentReply.${this.commentReply}.failed`, {
          commentHTML: data.commentHTML
        });
      });
  }

  updateComment(event, data) {
    CommentRepliesEditor.updateAndRender(
      this.commentId,
      data.replyId,
      data.commentHTML
    )
      .then(response => {
        const html = response.data;
        window.editedInfo = html;
        const $questionCommentList = $('.js-question-replies', this.$context);
        const content = $(html).find('.js-question-reply-text').html();
        const $questionComment = $(
          `#question-reply-${data.replyId}`,
          this.$context
        );

        $questionComment.find('.js-question-reply-text').html(content);

        EventManager.publish(`commentReply.${data.replyId}.saved`);
        $('html, body').animate(
          { scrollTop: $questionCommentList.offset().top - 40 },
          700
        );
        toastr.success('Comentário atualizado com sucesso');
      })
      .catch(() => {
        EventManager.publish(`commentReply.${data.replyId}.failed`, {
          commentHTML: data.commentHTML
        });
      });
  }

  deleteComment(event, data) {
    ModalManager.open('#js-confirm-delete-comment-modal', res => {
      if (res === true) {
        this.delete(data.replyId)
          .then(() => {
            const $questionComment = $(
              `#question-reply-${data.replyId}`,
              this.$context
            );
            $questionComment.fadeOut();

            toastr.success('Comentário excluido com sucesso');
          })
          .catch(() => {
            toastr.error(
              'Ops! Não foi possível excluir o comentário nesse momento!'
            );
          });
      }
    });
  }

  delete(replyId) {
    return new Promise((resolve, reject) => {
      Thor.Commentary.delete(
        {
          question_id: this.commentId,
          id: replyId
        },
        {}
      )
        .then(html => resolve(html))
        .catch(({ response }) => {
          const defaultMessage =
            'Ops! Não foi possivel excluir o seu comentário nesse momento!';
          const errors = response?.responseJSON?.errors?.text || [
            defaultMessage
          ];
          handleApiError(defaultMessage, response);
          reject(errors);
        });
    });
  }
}
